import React from 'react';
import { connect } from 'react-redux';
import Popover from 'react-bootstrap/lib/Popover';
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import util from '../../../lib/util';
import Switch from 'react-bootstrap-switch';
import EmailBox from '../../../components/Enhanced/EmailBox';

class Notifications extends React.Component {
  constructor(props) {	
    super(props);
    props.initAPI();
    this.state = { emailListCount : 0, index :-1};
  }

  componentDidMount() {
    this.loadEmailList();
  }

   componentWillReceiveProps(p) {         
    if (p.emailList && p.emailList.length != this.state.emailListCount) {
         this.loadEmailList();
         this.props.resetEmailToAdd();
    }
  }

  loadEmailList= () =>{
    const p = this.props;
    if(p.emailList) {
        p.emailList.map(x => {     
           p.setEmail(x.id,x.email);
        });
    }
     this.setState({ emailListCount: p.emailList.length });
  }

    onToggleClick = (item) => {         
        const p = this.props;
        const modalLookup= window.osa && window.osa.commonLookup.modal;
    
        let model = {
                    Email: item.email,
                    OldEmail: item.email,
                    IsActive: !item.isActive,
                    ProjectNo: p.project.projectNo,
                    ServiceAddress: util.addressToString( p.project.siteAddress)
                };
        if(item.isActive) {
            const data = {
            headerText: modalLookup.cancelService.header,
            bodyText: 'If you turn off notifications, you will no longer receive emails about your service request. Are you sure you want to turn notifications off?',
            actionButtonText: "OK",
            closeButtonText: "Cancel",
            onActionClicked: () => {              
                p.updateNotification(model);            
                }
            };
            p.showModal(data);
        }
        else {
            p.updateNotification(model);
        }
    }

    onUpdateEmailClick = (item,index) => {         
        const p = this.props;      
          
        const name = "email_" +item.id;
         this.setState({ index });
        let validators = [     
           [name, p => p[name], "Email"]
        ];      
        if (util.validate(validators, p.form, p.formError)) {            
               let model = {
                Email: p.form[name],
                OldEmail: item.email,
                IsActive: item.isActive,
                ProjectNo: p.project.projectNo,
                ServiceAddress: util.addressToString( p.project.siteAddress)
            };
           p.updateNotification(model);
        }
       
    }
    
    onDeleteEmailClick = (item) => {
        const p = this.props;
        const modalLookup= window.osa && window.osa.commonLookup.modal;
        const data = {
        headerText: modalLookup.cancelService.header,
        bodyText: 'Are you sure you want to delete this email address?',
        actionButtonText: "OK",
        closeButtonText: "Cancel",
        onActionClicked: () => {
                let model = {
                    Email: item.email,
                    ProjectNo:  p.project.projectNo
                };
                p.deleteEmail(model);            
            }
        };
        p.showModal(data);
    }
  onAddEmailClick = () => {
     const p = this.props;
    let validators = [     
      ['emailToAdd', p => p.emailToAdd , 'Email'],
      ['emailToAdd', p => !p.emailToAdd ||   util.isEmailValid(p.emailToAdd), '#Email is invalid']
    ];
    if (util.validate(validators, p.form, p.formError)) {
        const model = {
            Email: p.emailToAdd,
            ProjectNo: p.project.projectNo,
            ServiceAddress: util.addressToString( p.project.siteAddress)
        };      
       p.addEmail(model);
    }
  }
  render() {
    const p = this.props;
    const el= p.emailList;
    const error = (p.emailToAdd && p.addEmailSuccess && !p.addEmailSuccess.isSuccess && p.addEmailSuccess.message);
     const updateError =  (p.updateNotificationSuccess && !p.updateNotificationSuccess.isSuccess && p.updateNotificationSuccess.message);
    const tip = "An email is verified when the owner of the email has consented to receive electronic communications from FortisBC and they have clicked the link in the confirmation email. Otherwise the email is considered pending."
    return (
       <div>
         { 
          el.map((x, i)=>  
          <div>
           <div className="row" >
                <div className="col-md-8"  style={{ width: "65%" }}>
                    <div className="row">
                        <div className="col-md-4">
                            { i == 0 ? <label>Email notifications </label> : null }
                        </div>
                        <div className="col-md-2">
                            <div className="checkbox" style={{ padding: "0px" }}>
                                <Switch  value={x.isActive} bsSize="mini" onChange={ this.onToggleClick.bind(this,x)}  />
                            </div>
                        </div>
                        <div className="col-md-6">
                             <EmailBox id={'email_'+ x.id} name={'email_'+ x.id} errorMsg='Email is required' required /> 
                              { updateError && i == this.state.index ? <label className="control-label has-error validationMessage">{updateError}</label> : null}
                             <div className="rgt">
                                <OverlayTrigger trigger={['hover', 'focus']} placement="right" overlay={(<Popover id={`tt`+ x.id}>{tip}</Popover>)}>
                                <i className="fa fa-info-circle info-icon" />
                                </OverlayTrigger>            
                            </div>         
                        </div>
                    </div>
                </div>
            
                <div className="col-md-4"  style={{ width: "35%" }}>
                    <div className="row">
                        <div className="col-md-4" >
                            <div style={{ textAlign: "left" }}>
                                { x.isVerified?
                                <label style={{ color: "darkgreen" }}><i className="fa fa-check" style={{ color: "darkgreen" }}></i> Verified</label>
                                :
                                <label style={{ color: "red" }}><i className="fa fa-minus"  style={{ color: "red" }}></i> Pending</label>
                                }
                            </div>
                        </div>
                        <div className="col-md-4"  style={{ padding: "0px" }}>
                            <div>
                                <button type="button"  onClick={this.onUpdateEmailClick.bind(this,x,i)}  className="btn btn-link"><i className="fa fa-pencil-square-o"></i> Update</button>
                            </div>
                        </div>
                        <div className="col-md-4"  style={{ padding: "0px" }}>
                            <div>
                                <button type="button"  onClick={this.onDeleteEmailClick.bind(this,x)} className="btn btn-link"><i className="fa fa-minus-square"  style={{ color: "red" }}></i> Delete</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>          
            </div>)   
          }
        <div className="row form-group">
            <div className="col-md-8" style={{ width: "65%" }}>
                <div className="row">
                    <div className="col-md-6" style={{ height: "15px" }}></div>
                    <div className="col-md-6">
                        <EmailBox name="emailToAdd" errorMsg='Email is required' required /> 
                     <div className="rgt">
                        <OverlayTrigger trigger={['hover', 'focus']} placement="right" overlay={(<Popover id={`tt`}>{tip}</Popover>)}>
                        <i className="fa fa-info-circle info-icon" />
                    </OverlayTrigger>   
                    </div>
                   { error ? <label className="control-label has-error validationMessage">{error}</label> : null}
                    </div>
                </div>
            </div>
            <div className="col-md-4"style={{ width: "35%" }}>
                <button type="submit" onClick={this.onAddEmailClick} className="btn btn-link"><i className="fa fa-plus-square" style={{ color: "#428BCA" }}></i> Add email contact</button>
            </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    form: state.form,  
    emailToAdd : state.form.emailToAdd,
    project : state.gas.projectDetails && state.gas.projectDetails.data,
    emailList : state.gas.projectDetails && state.gas.projectDetails.emailList,
    addEmailSuccess : state.gas.addEmailSuccess,
    updateNotificationSuccess : state.gas.updateNotificationSuccess,   
  };
}
function mapDispatchToProps(dispatch) {
    return {          
        initAPI :() => dispatch({ type: 'INITIALIZE_API' }),
        showModal : (data) =>    dispatch({ type: 'SHOW_MODAL', data }),
        formError: (name, error) => dispatch({ type: 'FORM_ERROR', name, error }),
        setEmail : (id, email) => dispatch( { type: 'textbox',name: 'email_'+ id, value: email } ),
        resetEmailToAdd : () =>  dispatch( { type: 'textbox',name: 'emailToAdd', value: null } ),
        addEmail : (model) => dispatch({ type: 'ADD_EMAIL',model }),
        deleteEmail : (model) => dispatch({ type: 'DELETE_EMAIL', model }),
        updateNotification : (model) => dispatch({ type: 'UPDATE_NOTIFICATION', model })
    };
}
export default connect(mapStateToProps,mapDispatchToProps)(Notifications);

